import { render, staticRenderFns } from "./AiPrompts.vue?vue&type=template&id=1b404dc2&scoped=true"
import script from "./AiPrompts.vue?vue&type=script&lang=js"
export * from "./AiPrompts.vue?vue&type=script&lang=js"
import style0 from "./AiPrompts.vue?vue&type=style&index=0&id=1b404dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b404dc2",
  null
  
)

export default component.exports